import { Api } from '@/services/Api'

export default {
  getPlantDetail(plantId) {
    return Api().get(`/api/v2/plant-device/${plantId}`)
  },
  updatePlantDetail(param) {
    return Api().patch('/api/v2/plant-device', param)
  }
}
